module.exports = __webpack_public_path__ + "static/media/bulle-ecailles.6c1acb9a.png";